import {messageType} from '@/util/dictList.js'
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: false,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '消息类型',
      prop: 'messageTypeParentList',
      type: 'select',
      filterable: true,
      multiple: true,
      addDisplay: true,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      hide: true,
      dicData: messageType,
    },
    {
      label: '租赁人',
      prop: 'name',
      span: 24,
      display: false,
      searchOrder: 1000,
    },
    // {
    //   label: '手机号',
    //   prop: 'phone',
    //   search: true,
    //   maxlength:11,
    // },
    {
      label: 'id',
      prop: 'id',
      display: false,
      hide: true,
    },
    {
      label: '发送时间',
      prop: 'dateTime',
      type: 'daterange',
      search: true,
      hide: true,
      searchRange: true,
      display: false,
      // dataType: 'string',
      valueFormat: 'yyyy-MM-dd',
    },
    {
      label: '发送时间',
      width: 90,
      prop: 'createTime',
      type: 'input',
      search: false,
    },
    {
      label: '消息类型',
      prop: 'messageTypeParent',
      display: false,
      type: 'select',
      search: false,
      dicData: messageType,
    },
    {
      label: '消息内容',
      prop: 'msgContent',
      span: 24,
      display: false,
    },
  ],
};
